import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { List, ListItem, ListItemIcon } from '@mui/material';

import { ReactComponent as CheckmarkIcon } from 'assets/icons/CheckmarkIcon.svg';

import { ISubscriptionDetailsListProps as IProps } from './types';

import styles from './SubscriptionDetailsList.module.scss';

export const SubscriptionDetailsList: FC<IProps> = ({ detailsList }) => {
  const { t } = useTranslation();

  const resolveDetail = (detail: string | { key: string; params?: Record<string, any> }) => {
    if (typeof detail === 'string') {
      return t(detail);
    }
    return t(detail.key, detail.params);
  };

  return (
    <List className={styles.list}>
      {detailsList.map((detail, index) => (
        <ListItem className={styles.listItem} key={index} disablePadding>
          <ListItemIcon className={styles.listIcon}>
            <CheckmarkIcon />
          </ListItemIcon>
          {resolveDetail(detail)}
        </ListItem>
      ))}
    </List>
  );
};
